module.exports = __webpack_public_path__ + "img/happytable_info4.4911c5b3.jpg";